import { createWorkOrderAssetsTabState } from "../types/work-order-assets-tab-state/work-order-assets-tab-state.functions";
import { WorkOrderAssetsTabState } from "../types/work-order-assets-tab-state/work-order-assets-tab-state.interface";
import {
  WorkOrderAssetsTabActions,
  WorkOrderAssetsTabActionType,
} from "./work-order-assets-tab.actions";

export function workOrderAssetsTabReducer(
  state = createWorkOrderAssetsTabState(),
  action: WorkOrderAssetsTabActionType
): WorkOrderAssetsTabState {
  switch (action.type) {
    case WorkOrderAssetsTabActions.FetchAssets:
    case WorkOrderAssetsTabActions.UploadAssets:
    case WorkOrderAssetsTabActions.DeleteAsset:
      return {
        ...state,
        isLoading: true,
      };
    case WorkOrderAssetsTabActions.SetAssets:
      return {
        ...state,
        assets: action.payload,
      };
    case WorkOrderAssetsTabActions.FetchAssetsSuccess:
    case WorkOrderAssetsTabActions.UploadAssetsSuccess:
    case WorkOrderAssetsTabActions.DeleteAssetSuccess:
      return {
        ...state,
        isLoading: false,
      };
    case WorkOrderAssetsTabActions.UploadAssetsFailure:
    case WorkOrderAssetsTabActions.FetchAssetsFailure:
    case WorkOrderAssetsTabActions.DeleteAssetFailure:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case WorkOrderAssetsTabActions.Reset:
      return createWorkOrderAssetsTabState();
    default:
      return state;
  }
}
